<div [formGroup]="formSearch">
  <div class="mb-3 flex justify-between items-center gap-3">
    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Codigo tg</mat-label>
      <input matInput formControlName="tgCode" />
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Codigo OS</mat-label>
      <input matInput formControlName="osCode" />
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Cliente</mat-label>
      <input matInput formControlName="client" />
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Serviço</mat-label>
      <input matInput formControlName="service" />
    </mat-form-field>
  </div>
  <div class="mb-3 flex justify-between items-center gap-3">
    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Origem</mat-label>
      <input matInput formControlName="origin" />
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Destino</mat-label>
      <input matInput formControlName="destination" />
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Tipo Veículo</mat-label>
      <input matInput formControlName="vehicleType" />
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Tipo Motorista</mat-label>
      <input matInput formControlName="driverType" />
    </mat-form-field>
  </div>
  <div class="mb-3 flex justify-between items-center gap-3">
    <mat-form-field
      class="input-tg search-tg no-message-new w-6/12"
      appearance="outline"
    >
      <mat-label>Status da OS</mat-label>
      <mat-select formControlName="statusOsId">
        <mat-option [value]="''">Todos</mat-option>
        @for (status of statusOsList; track status.id) {
          <mat-option [value]="status.id">{{ status.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="mb-3 flex justify-between items-center gap-3">
    <mat-form-field
      class="input-tg search-tg no-message-new w-4/12"
      appearance="outline"
    >
      <mat-label>Data inicio</mat-label>
      <input
        matInput
        [matDatepicker]="dateStart"
        (focus)="openDatepicker('dateStart')"
        formControlName="dateStart"
        readonly
        [max]="formSearch.get('dateEnd')!.value"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="dateStart"
      ></mat-datepicker-toggle>
      <mat-datepicker #dateStart></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-4/12"
      appearance="outline"
    >
      <mat-label>Data fim</mat-label>
      <input
        matInput
        [matDatepicker]="dateEnd"
        (focus)="openDatepicker('dateEnd')"
        formControlName="dateEnd"
        readonly
        [min]="formSearch.get('dateStart')!.value"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="dateEnd"
      ></mat-datepicker-toggle>
      <mat-datepicker #dateEnd></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="mb-3 flex justify-end items-center gap-2">
    <button
      class="btn-icon"
      (click)="sendSearch(false)"
      [matTooltip]="'Limpar Pesquisar'"
    >
      <mat-icon>replay</mat-icon>
    </button>
    <button class="btn-icon" (click)="sendSearch()" [matTooltip]="'Pesquisa'">
      <mat-icon>search</mat-icon>
    </button>
  </div>
</div>
